enum FundingAccountActionType {
    FUNDING_ACCOUNT_REQUEST_DATA = "FUNDING_ACCOUNT_REQUEST_DATA",
    FUNDING_ACCOUNT_LOAD_DATA = "FUNDING_ACCOUNT_LOAD_DATA",
    FUNDING_ACCOUNT_PREPEND_DATA = "FUNDING_ACCOUNT_PREPEND_DATA",
    FUNDING_ACCOUNT_DISPLAY_ERROR = "FUNDING_ACCOUNT_DISPLAY_ERROR",
    FUNDING_ACCOUNT_SELECT_ACCOUNT = "FUNDING_ACCOUNT_SELECT_ACCOUNT"
}

export default FundingAccountActionType;